import React from 'react';

import ComposerLanguageSelect from './ComposerLanguageSelect';

const MultiComposerLanguageSelect = props => (
  <ComposerLanguageSelect {...props} />
);

export default MultiComposerLanguageSelect;
